<div class="row" style="height: 550px;">
  <div [hidden]="!isEditing" class="col-sm-5">
    <h3>All available partners</h3>
    <dx-data-grid #gridAvailablePartners
      biz-grid
      height="350"
      [bizSetScrolling]="false"
      [bizSetGroupPanel]="false"
      [bizSetPager]="false"
      [bizSetExport]="false"
      [bizSetStateStoring]="false"
      [bizSetColumnChooser]="false"
      [bizSetAllowColumnReordering]="false"
      [showResetButton]="false"
      [dataSource]='availablePartners'
      (onSelectionChanged)='selectionChangedAvailablePartners($event)'>
      <dxo-scrolling mode="virtual"></dxo-scrolling>
      <dxo-selection mode="multiple"></dxo-selection>
      <dxi-column dataField="PartnerName" caption="Name" dataType="string" width="50%"></dxi-column>
      <dxi-column dataField="MainIdentificationName" caption="Identification type" dataType="string" width="25%"></dxi-column>
      <dxi-column dataField="MainIdentificationValue" caption="Identification" dataType="string" width="25%"></dxi-column>
    </dx-data-grid>
  </div>
  <div [hidden]="!isEditing" class="col-sm-2" style="padding-top: 130px;">
    <button class="form-control" (click)="addSelectedPartners()"> >> </button>
    <br />
    <br />
    <button class="form-control" (click)="removeSelectedPartners()"> << </button>
  </div>
  <div [ngClass]="{'col-sm-5': isEditing, 'col-sm-12': !isEditing}">
    @if (allowEdit) {
      <h3>Partners connected to this proxy partner</h3>
    }
    @if (!allowEdit) {
      <h3>This partner is connected to the following proxy partners</h3>
    }
    <dx-data-grid #gridSelectedPartners
      biz-grid
      height="350"
      [bizSetScrolling]="false"
      [bizSetGroupPanel]="false"
      [bizSetPager]="false"
      [bizSetExport]="false"
      [bizSetStateStoring]="false"
      [bizSetColumnChooser]="false"
      [bizSetAllowColumnReordering]="false"
      [showResetButton]="false"
      [dataSource]='partnerConnections'
      (onSelectionChanged)='selectionChangedSelectedPartners($event)'>
      <dxo-scrolling mode="virtual"></dxo-scrolling>
      <dxo-selection [mode]="isEditing ? 'multiple' : 'none'"></dxo-selection>

      <dxi-column dataField="PartnerName" caption="Name" dataType="string" width="50%"></dxi-column>
      <dxi-column dataField="MainIdentificationType.IdentificationType.Name" caption="Identification type" dataType="string" width="25%"></dxi-column>
      <dxi-column dataField="MainIdentificationType.Value" caption="Identification" dataType="string" width="25%"></dxi-column>
    </dx-data-grid>
  </div>
</div>
@if (allowEdit) {
  <div class="btn-toolbar form-group">
    @if (!isEditing) {
      <div class="btn-group">
        <button class="btn btn-primary" type="button" (click)="edit()" *bizPermissionRequired="['Partner_Action_ProxyPartnerEdit', 'Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: selectedPartner">Edit</button>
      </div>
    }
    @if (isEditing) {
      <div class="btn-group">
        <button class="btn btn-primary" type="button" (click)="save()">Save</button>
      </div>
    }
    @if (isEditing) {
      <div class="btn-group">
        <button class="btn btn-link" type="button" (click)="cancel()">Cancel</button>
      </div>
    }
  </div>
}
